import { dbPost } from '../../../apis/commonApi';

class ExpertConsultDetailController {
  initialState = {
    picNm: '',
    taskNm: '',
    status: '',
    text0: '',
  };

  constructor(
    store,
    modalService,
    validateService,
    svcObj,
    { detailList, setDetailList },
    rsltList,
    cnsltList
  ) {
    this.store = store;
    this.modalService = modalService;
    this.validateService = validateService;
    this.svcObj = svcObj;
    this.detailList = detailList;
    this.setDetailList = setDetailList;
    this.rsltList = rsltList;
    this.cnsltList = cnsltList;
  }

  // 조회
  async fnGetExpertConsultDetail() {
    let response = null;

    try {
      response = await dbPost('/expert-consult/detail/list.do', this.svcObj);
      if (response instanceof Error) {
        this.modalService.errorAlert(
          '데이터 처리중 에러가 발생하였습니다',
          () => {}
        );
      } else {
        this.setDetailList(response);

        // rsltList.current 동기화
        this.rsltList.current = response.map((item, index) => ({
          index,
          ...item,
        }));
      }
    } catch (error) {
      this.modalService.errorAlert(
        '데이터 처리중 에러가 발생하였습니다',
        () => {}
      );
    }
  }

  // 분석 완료, 임시저장
  async fnSave(isTemp) {
    if (this.fnValidate(isTemp)) {
      try {
        const response = await dbPost('/expert-consult/detail/add.do', {
          isTemp: isTemp,
          exprtCnsltId: this.svcObj.exprtCnsltId,
          exprtAnlsDtlId: this.svcObj.exprtAnlsDtlId,
          entNm: this.svcObj.entNm,
          tpbizTypeNm: this.svcObj.tpbizTypeNm,
          taskNm: this.svcObj.taskNm,
          cnsltDmndDt: this.svcObj.cnsltDmndDt,
          userNm: this.svcObj.userNm,
          exprtAnlsId: this.svcObj.exprtAnlsId,
          rsltList: this.rsltList.current,
          cnsltList: this.cnsltList.current,
        });

        if (response instanceof Error) {
          this.modalService.errorAlert(
            '데이터 처리중 에러가 발생하였습니다',
            () => {}
          );
        } else {
          if (isTemp != 'Y') {
            if (isTemp === 'CNSLT02') {
              this.modalService.successAlert('컨설팅 등록이 완료 되었습니다.');
            } else if (isTemp === 'CNSLT03') {
              this.modalService.successAlert(
                '수행사항 등록이 완료 되었습니다.'
              );
            } else if (isTemp === 'CNSLT04') {
              this.modalService.successAlert(
                '수행여부 등록이 완료 되었습니다.'
              );
            }
            this.svcObj.cnsltSttsCd = isTemp;
          } else {
            this.modalService.successAlert('임시저장 되었습니다.');
          }
        }
      } catch (error) {
        this.modalService.errorAlert(
          '데이터 처리중 에러가 발생하였습니다',
          () => {}
        );
      }
    }
  }

  fnValidate(isTemp) {
    let errorMsg = '';
    let cnt = 0;

    if (isTemp != 'Y') {
      for (let i = 0; i < this.rsltList.current.length; i++) {
        const detail = this.rsltList.current[i].improvementList;

        if (isTemp == 'CNSLT02') {
          if (detail.length < 1) {
            errorMsg += `<b style='line-height: 2.5;'>${this.rsltList.current[i].workNm}</b><br />`;
            errorMsg += '개선사항을 입력해주세요<br />';
          }
          for (
            let j = 0;
            j < this.rsltList.current[i].improvementList.length;
            j++
          ) {
            if (
              this.rsltList.current[i].improvementList[j].cnsltCn == null ||
              this.rsltList.current[i].improvementList[j].cnsltCn === '' ||
              (this.rsltList.current[i].improvementList[j].etcYn === 'N' &&
                this.rsltList.current[i].improvementList[j].mngYn === 'N' &&
                this.rsltList.current[i].improvementList[j].riskDcrsYn ===
                  'N' &&
                this.rsltList.current[i].improvementList[j].techYn === 'N')
            ) {
              cnt++;
            }
          }
          if (cnt > 0) {
            errorMsg =
              '모든 작업에 대한 개선사항 또는 개선방안을 입력해주세요<br />';
          }
        }
        if (isTemp == 'CNSLT03') {
          for (
            let j = 0;
            j < this.rsltList.current[i].improvementList.length;
            j++
          ) {
            if (
              this.rsltList.current[i].improvementList[j].flfmtCn == null ||
              this.rsltList.current[i].improvementList[j].flfmtCn === ''
            ) {
              cnt++;
            }
          }

          if (cnt > 0) {
            errorMsg = '모든 작업에 대한 수행사항을 입력해주세요<br />';
          }
          // if (
          //   this.rsltList.current[i].vldAplyStts == null ||
          //   this.rsltList.current[i].vldAplyStts != 'C'
          // ) {
          //   cnt++;
          // }

          // if (cnt > 0) {
          //   errorMsg = '검증영상 업로드 후 부가정보를 입력해 주세요<br />';
          // }
        }

        if (isTemp == 'CNSLT04') {
          for (
            let j = 0;
            j < this.rsltList.current[i].improvementList.length;
            j++
          ) {
            if (
              this.rsltList.current[i].improvementList[j].flfmtYn == null ||
              this.rsltList.current[i].improvementList[j].flfmtYn === ''
            ) {
              cnt++;
            }
          }
          if (cnt > 0) {
            errorMsg = '모든 작업에 대한 수행여부를 체크해주세요<br />';
          }
        }
      }
    }
    if (errorMsg.length === 0) {
      return true;
    } else {
      this.modalService.noticeAlert(errorMsg);
      return false;
    }
  }

  async valueObjChange(model, value) {
    this.setValueObj({ ...this.valueObj, [model]: value });
  }

  async gridHeaderClick(col) {}

  async gridCellClick(row, col, rowData) {
    this.navigate('/ExpertConsultDetail', {
      state: {
        userId: rowData.userId,
        taskNm: rowData.taskNm,
      },
    });
  }

  async fnUploadVdo() {
    this.modalService.openModal(
      'UploadVdoForValidation',
      {
        entSn: this.svcObj?.entSn,
        aiaAplyId: this.svcObj?.aiaAplyId,
        vldAplyId: this.detailList[0].vldAplyId ?? null,
        cnsltSttsCd: this.detailList[0].cnsltSttsCd ?? null,
        exprtCnsltId: this.svcObj?.exprtCnsltId,
      },
      () => {
        this.fnGetExpertConsultDetail();
      }
    );
  }
}

export default ExpertConsultDetailController;
